import GoogleAuthButton from "./GoogleAuthButton";

export default GoogleAuthButton
